import { Directive, HostListener, inject } from '@angular/core';

import { VudDropdownDirective } from './vud-dropdown.directive';

@Directive({
  selector: '[diVudDropdownToggle]',
  standalone: true,
})
export class VudDropdownToggleDirective {
  private readonly dropdown = inject(VudDropdownDirective);

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.dropdown.toggle();
  }
}
